import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom"; // Import useHistory for navigation
import favicon from "../../assets/images/V1LOGO.png"; // Your logo
import apiUrls from "../../summaryapi/apiUrls"; // Import API URLs
import { AuthContext } from "../../common/index";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { toast } from "react-toastify";
import { logEmployeeAction } from "../../loginactions/index";
const Login = ({ onLogin }) => {
  const [user_name, setUser_name] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State for password visibility
  const history = useHistory(); // Initialize useHistory
  const { fetchEmployeeRoles } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(apiUrls.adminLogin.url, {
        method: apiUrls.adminLogin.method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_name, password }),
      });
      const data = await response.json();
      if (response.ok && data.status) {
        console.log("Login Success:", data);
        sessionStorage.setItem("adminUsername", btoa(user_name));
        sessionStorage.setItem("adminId", btoa(data.admin_id));
        sessionStorage.setItem("adminMode", btoa(data.mode));
        onLogin();
        fetchEmployeeRoles(data.admin_id);
        await logEmployeeAction('LOGIN');
        toast.success("Login successful! Redirecting...",);
        history.push("/dashboards/crm");
      } else {
        console.log("Invalid Login:", data);
        toast.error(data.message || "Invalid credentials!");
      }
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className="login-container d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #ff0000, #ffffff)",
      }}
    >
      <div className="card shadow-lg p-4" style={{ width: "100%", maxWidth: "400px" }}>
        <div className="d-flex justify-content-center align-items-center mb-4">
          <img
            src={favicon}
            alt="Logo"
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
            }}
          />
          <h2 className="ml-3" style={{ color: "#2c3e50" }}>
            Login
          </h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="user_name" className="form-label" style={{ color: "#2c3e50" }}>
              Username
            </label>
            <input
              type="text"
              className="form-control"
              id="user_name"
              value={user_name}
              onChange={(e) => setUser_name(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label" style={{ color: "#2c3e50" }}>
              Password
            </label>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control pe-5"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ paddingRight: "2.5rem" }}
              />
              <button
                type="button"
                className="btn btn-link position-absolute end-0 top-50 translate-middle-y"
                onClick={togglePasswordVisibility}
                style={{
                  color: "#6c757d",
                  padding: "0.375rem",
                  right: "0.5rem",
                  border: "none",
                  background: "transparent",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <button type="submit" className="btn btn-primary w-100 py-2">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;